import { usePageStore } from "@voix/store/pageStore";
function buildHeadData() {
  const pageStore = usePageStore();
  const head = {
    htmlAttrs: {
      lang: pageStore.currentPage?.language_code || "en"
    },
    link: [],
    style: [],
    script: [],
    noscript: []
  };
  addCanonical(head);
  addStructuredDateMarkup(head);
  addScripts(head);
  addStyles(head);
  addExternalScripts(head);
  addNoscripts(head);
  return head;
}
function addStyles(head) {
  const pageStore = usePageStore();
  if (pageStore.currentPage) {
    const pageTagsOnly = pageStore.currentPage.head_tags.filter((x) => x.type === "style");
    const globalTagsOnly = pageStore.currentPage?.global_head_tags.filter((x) => x.type === "style");
    const allTags = [...pageTagsOnly, ...globalTagsOnly];
    const finalTags = allTags.map((tag) => {
      return {
        children: tag.content
      };
    });
    head.style = [...head.style, ...finalTags];
  }
}
function addCanonical(head) {
  const pageStore = usePageStore();
  const pageCanonical = pageStore.currentPage?.head_tags.find((x) => x.type === "canonical")?.content;
  if (pageCanonical) {
    return head.link.push({
      rel: "canonical",
      href: pageCanonical
    });
  }
}
function addStructuredDateMarkup(head) {
  const pageStore = usePageStore();
  if (pageStore.currentPage) {
    const pageTagsOnly = pageStore.currentPage.head_tags.filter((x) => x.type === "structuredDataMarkup");
    const globalTagsOnly = pageStore.currentPage?.global_head_tags.filter((x) => x.type === "structuredDataMarkup");
    const allTags = [...pageTagsOnly, ...globalTagsOnly];
    const finalTags = allTags.map((tag) => {
      return {
        type: "application/ld+json",
        innerHTML: tag.content,
        tagPosition: tag.position
      };
    });
    head.script = [...head.script, ...finalTags];
  }
}
function addScripts(head) {
  const pageStore = usePageStore();
  if (pageStore.currentPage) {
    const pageTagsOnly = pageStore.currentPage.head_tags.filter((x) => x.type === "script");
    const globalTagsOnly = pageStore.currentPage?.global_head_tags.filter((x) => x.type === "script");
    const allTags = [...pageTagsOnly, ...globalTagsOnly];
    const finalTags = allTags.map((tag) => {
      return {
        type: tag.is_partytown ? "text/partytown" : "text/javascript",
        innerHTML: tag.content,
        tagPosition: tag.position
      };
    });
    head.script = [...head.script, ...finalTags];
  }
}
function addExternalScripts(head) {
  const pageStore = usePageStore();
  if (pageStore.currentPage) {
    const pageTagsOnly = pageStore.currentPage.head_tags.filter((x) => x.type === "externalScript");
    const globalTagsOnly = pageStore.currentPage?.global_head_tags.filter((x) => x.type === "externalScript");
    const allTags = [...pageTagsOnly, ...globalTagsOnly];
    const finalTags = allTags.map((tag) => {
      return {
        type: tag.is_partytown ? "text/partytown" : "text/javascript",
        src: tag.content,
        tagPosition: tag.position
      };
    });
    head.script = [...head.script, ...finalTags];
  }
}
function addNoscripts(head) {
  const pageStore = usePageStore();
  if (pageStore.currentPage) {
    const pageTagsOnly = pageStore.currentPage.head_tags.filter((x) => x.type === "noscript");
    const globalTagsOnly = pageStore.currentPage?.global_head_tags.filter((x) => x.type === "noscript");
    const allTags = [...pageTagsOnly, ...globalTagsOnly];
    const finalTags = allTags.map((tag) => {
      return {
        type: "noscript",
        innerHTML: tag.content,
        tagPosition: tag.position
      };
    });
    head.noscript = [...head.noscript, ...finalTags];
  }
}
function buildSeoMetaData() {
  const meta = {};
  const pageStore = usePageStore();
  if (pageStore.currentPage) {
    const nonMetaTypes = ["canonical", "script", "externalScript", "style", "externalStyle", "structuredDataMarkup", "noscript"];
    const pageMetaTagsOnly = pageStore.currentPage?.head_tags.filter((x) => !nonMetaTypes.includes(x.type));
    const globalMetaTagsOnly = pageStore.currentPage?.global_head_tags.filter((x) => !nonMetaTypes.includes(x.type));
    const allMetaTags = [...pageMetaTagsOnly, ...globalMetaTagsOnly];
    const filteredMetaTags = getUniqueTags(allMetaTags);
    filteredMetaTags.forEach((tag) => {
      meta[tag.type] = tag.content;
    });
  }
  return meta;
}
function getUniqueTags(tags) {
  const usedTypes = [];
  return tags.filter((tag) => {
    if (!usedTypes.includes(tag.type)) {
      usedTypes.push(tag.type);
      return true;
    }
    return false;
  });
}
export {
  buildHeadData,
  buildSeoMetaData
};
